import { connect, MapStateToProps } from "react-redux";

import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { getOpenedFormsIds } from "../../openedItems";
import { QuickAccessOpenedItemsComponent, QuickAccessOpenedItemsComponentProps } from "../QuickAccessOpenedItemsComponent";

const mapStateToProps: MapStateToProps<QuickAccessOpenedItemsComponentProps, NoneOwnProps, IAppState> = (state) => ({
    openedFormsIds: getOpenedFormsIds(state),
});

export const QuickAccessOpenedItems = connect(mapStateToProps)(QuickAccessOpenedItemsComponent);
